import RoleFilterTabs from './RoleFilterTabs';

export default RoleFilterTabs;
